import { ThemeOptions } from '@mui/material';

export const themeFormControl: ThemeOptions['components'] = {
  MuiFormControl: {
    defaultProps: {
      size: 'small',
    },
  },
};
